export enum PredefinedItems {
    all = 'all',
    promotions = 'promotions',
    pinnedEvents = 'pinnedEvents',
}

export enum ItemType {
    sportId = 'sportId',
    tournamentId = 'tournamentId',
    categoryId = 'categoryId',
    specialOfferId = 'specialOfferId',
}

export enum MarketFilter {
    popular = 'popular',
    allMarkets = 'allMarkets',
    specialOffer = 'specials',
}
export enum EventTab {
    popular = 'popular',
    allMarkets = 'allMarkets',
    specialOffer = 'specials',
    chat = 'chat',
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/sportOffer/sports/enums.ts